export default __webpack_public_path__ + "static/media/events-banner.43c0071e.png";